(function () {
  angular
    .module("akitabox.planView.dialogs.markup.delete")
    .service("DeleteMarkupDialog", DeleteMarkupDialog);

  /* @ngInject */
  function DeleteMarkupDialog($mdDialog) {
    var modal = {
      templateUrl:
        "app/desktop/modules/plan-view/dialogs/markup/delete/delete-markup.dialog.html",
      controller: "DeleteMarkupDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    /**
     * DeleteMarkupDialog service
     *
     * @type {Object}
     */
    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog
     * `options.locals.markup` is required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error>}              Promise that resolves when the markup is deleted
     */
    function show(options) {
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
